import React, {useState, useEffect, useReducer} from "react";
import { CircularProgress, Fade, Button } from "@mui/material";
import { styled } from '@mui/material/styles';
import {Swiper, SwiperSlide} from "swiper/react";

import 'swiper/css';

const ColorButton = styled(Button)(({ theme }) => ({
    color: '#fff',
    backgroundColor: '#2642a6',
    '&:hover': {
      backgroundColor: '#152e87',
    },
    fontWeight: '700'
  }));

const GFK_CATEGORIES_ENDPOINT = 'https://horyzontgfk.pl/wp-json/horyzont/v1/get_categories/';
 

const categoriesReducer = (state, action) => {
	switch(action.type) {
		case 'FETCH_CATEGORIES_START':
			return {
				...state,
				isLoading: true,
			};
        case 'FETCH_CATEGORIES_TRANSITION':
            return {
                ...state,
                isLoading: true,
                data: action.payload
            }
		case 'FETCH_CATEGORIES_SUCCESS':
			return {
				...state,
				isLoading: false,
				data: action.payload,
			};
		default: 
			throw new Error();
	}
}

const FirstLevel = (props) => {
    const [show, setShow] = useState(false);
    const [showSpinner, setShowSpinner] = useState(true);
    const [categories, dispatchCategories] = useReducer(
        categoriesReducer,
        {data: [], isLoading: true},
    );

	useEffect(() => {
        setShow(false);
		dispatchCategories({ type: 'FETCH_CATEGORIES_START' });
        setShowSpinner(true);
		fetch(GFK_CATEGORIES_ENDPOINT+props.categoryId)
            // .then(sleeper(500))
			.then(response => response.json())
			.then(result => {
				dispatchCategories({
					type: 'FETCH_CATEGORIES_TRANSITION',
					payload: result,
				});
                setShowSpinner(false);
                setTimeout(() => {
                    dispatchCategories({
                        type: 'FETCH_CATEGORIES_SUCCESS',
                        payload: result
                    })
                    setShow(true);
                }, 200); 
			})
		.catch((e) => console.log("Error fetching: " + e))
	}, [props.categoryId]);

    return (
        <div className="gfk-select-container">
            
            {categories.isLoading ? (
                <Fade in={showSpinner}><div><CircularProgress /></div></Fade>
            ) : (
                <>
                    <Fade in={show} timeout={{ enter: 700, exit: 700 }} ><h2>{categories.data.title}</h2></Fade>
                
                <div className="gfk-select-inner">


                
                {categories.data.type === 'categories' ? (
                    <Swiper
                        centeredSlides='true'
                        slidesPerView='auto'
                        spaceBetween='20'
                        // loop='true'

                        breakpoints={{
                            1024: {
                                centerInsufficientSlides:'true',
                                centeredSlidesBounds:'true',
                                noSwiping: 'true',
                                allowSlidePrev: false,
                                allowSlideNext: false
                    
                            }
                        }}
                    >
                        {categories.data.categories.map((category, key) => {
                            return (
                                <SwiperSlide key={key} >
                                    <Fade in={show} timeout={{ enter: 500, exit: 500 }}  className="test" 
                                    style={{
                                        backgroundImage: 'url('+category.image+')',
                                        transitionDelay: `${key * 100}ms`
                                    }}>
                                    <div>
                                        <div>
                                            <p>{category.name}</p>
                                            <div className="gfk-children-list">
                                                {category.children.map((child, key) => {
                                                    return (
                                                        <span key={key} onClick={() => {
                                                            props.selectCategory(child.id);
                                                            setShow(false);
                                                        }}>{child.name}</span>
                                                    )}
                                                )}
                                            </div>
                                            <ColorButton  variant="contained" onClick={() => {
                                                props.selectCategory(category.id);
                                                setShow(false);
                                            }}>
                                                Przejdź
                                            </ColorButton >                                    
                                        </div>
                                    </div>
                                    </Fade>
                                </SwiperSlide>
                            )}
                        )}
                    </Swiper>

                ) : (
                    <>
                    {categories.data.products.map((product, key) => {
                            return (
                                <div key={key}>
                                    <Fade in={show} timeout={{ enter: 700, exit: 700 }} >
                                        <h2>Mamy dla Ciebie ofertę od ubezpieczycieli:</h2>
                                    </Fade>
                                    <div className="gfk-logos">
                                    {product.logos.map((logo, key) => {
                                        return (
                                            
                                            <Fade in={show} timeout={{ enter: 700, exit: 700 }} >
                                                <img src={logo}/>
                                            </Fade>
                                        )
                                    })}
                                    </div>

                                    <Fade in={show} timeout={{ enter: 700, exit: 700 }} >
                                    
                                        <div><ColorButton className="gfk-wide-button gfk-offer-button" href={product.link}>Przejdź do oferty</ColorButton></div>
                                    </Fade>
                                </div>
                            )}
                        )}
                    </>
                )}

               </div>
               </>
            )}
            <Fade in={show}  timeout={{ enter: 400, exit: 400 }} >
                <div className='gfk-back'>
                {props.history.length ? (
                    <>
                    <ColorButton onClick={() => {
                        props.handleClickBack();
                        setShow(false);
                    }} className="gfk-wide-button gfk-back-button">Powrót</ColorButton>
                    {/* <ColorButton onClick={() => {
                        props.handleClickBack();
                        setShow(false);
                    }}>Powrót</ColorButton> */}
                    </>
                ) : (
                    <></>
                )}
                </div>
            </Fade>
        </div>
    )
}

export default FirstLevel;